<app-modal *ngIf="vo$ | async; let vo" >
	<div modal-body class="app-orphan-project-action-popup">
		<ng-container [ngSwitch]="vo.action">
			<div *ngSwitchCase="OrphanProjectAction.BulkMap" class="app-orphan-project-action-popup__select-admin">
				<dc-alert message="message" i18n-message="@@orphan-project.action-popup.bulk-map.info"></dc-alert>

				<mat-form-field *ngIf="vo.admins">
					<mat-label i18n="@@orphan-projects.search-admin">Search Admin</mat-label>
					<input
						type="text"
						matInput
						[matAutocomplete]="auto"
						[ngModel]="vo.searchInput"
						(ngModelChange)="onSearchInputChange($event)" />
					<mat-autocomplete #auto="matAutocomplete">
						<mat-option *ngFor="let admin of vo.admins" [value]="admin.name" (onSelectionChange)="selected(admin.id)">
							{{ admin.name }}
						</mat-option>
					</mat-autocomplete>
				</mat-form-field>
			</div>

			<div *ngSwitchCase="OrphanProjectAction.ConfirmSave">
				<dc-alert [type]="'warning'" message="message" i18n-message="@@orphan-project.action-popup.save-unmapped.info"></dc-alert>
			</div>
		</ng-container>
	</div>

	<div modal-footer class="app-orphan-project-action-popup__footer">
		<ng-container [ngSwitch]="vo.action">
			<button
				id="{{ cmpId }}-confirm-btn"
				class="footer-btn"
				[color]="'primary'"
				[disabled]="
					modalData.action === OrphanProjectAction.BulkMap && !selectedAdmin
				"
				(click)="confirmAction()"
				mat-raised-button>
				<span i18n="@@general.action.confirmer">Confirm</span>
			</button>
		</ng-container>
	</div>
</app-modal>
